import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, HashRouter } from "react-router-dom";
import { supabase } from "./supabaseClient";
import Home from "./Home";
import Login from "./Login";
import Signup from "./SignUp";
import PostRegistration from "./PostRegistration";
import JoinAuction from "./JoinAuction";
import AuctionDetails from "./AuctionDetails";
import AuctionSetup from "./AuctionSetup";
import AuctionAdmin from "./AuctionAdmin";
import AuctionItems from "./AuctionItems";
import PlaceBid from "./PlaceBid";
import UserDashboard from "./UserDashboard";

function App() {
  const [user, setUser] = useState(null);
  const [auctionCodes, setAuctionCodes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initializeSession = async () => {
      setIsLoading(true);
      const {
        data: { session },
        error,
      } = await supabase.auth.getSession();

      if (error) {
        console.error("Error fetching session:", error.message);
        setUser(null);
      } else {
        setUser(session?.user || null);
        if (session?.user) {
          await fetchAuctionCodes(session.user.id);
        }
      }
      setIsLoading(false);
    };

    const { data: authListener } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setUser(session?.user || null);
        if (session?.user) fetchAuctionCodes(session.user.id);
      }
    );

    initializeSession();

    return () => {
      authListener?.subscription?.unsubscribe();
    };
  }, []);

  const fetchAuctionCodes = async (userId) => {
    try {
      const { data, error } = await supabase
        .from("auctions")
        .select("auction_code")
        .eq("user_id", userId);

      if (error) throw error;

      setAuctionCodes(data.map((auction) => auction.auction_code));
    } catch (err) {
      console.error("Error fetching auction codes:", err.message);
    }
  };

  const ProtectedRoute = ({ children }) => {
    return user ? children : <Navigate to="/login" replace />;
  };

  if (isLoading) return <p>Loading...</p>;

  return (
   
      <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login setUser={setUser} />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/post-registration" element={<PostRegistration />} />
        <Route path="/join-auction" element={<JoinAuction />} />
        <Route
          path="/auction-details/:auctionCode"
          element={
            <ProtectedRoute>
              <AuctionDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/auction-setup"
          element={
            <ProtectedRoute>
              <AuctionSetup user={user} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/auction-admin/:auctionCode"
          element={
            <ProtectedRoute>
              <AuctionAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/auction-items/:auctionCode"
          element={
            <ProtectedRoute>
              <AuctionItems />
            </ProtectedRoute>
          }
        />
        <Route
          path="/place-bid/:auctionCode/:itemId"
          element={
            <ProtectedRoute>
              <PlaceBid />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <UserDashboard user={user} auctionCodes={auctionCodes} />
            </ProtectedRoute>
          }
        />
      </Routes>
      </div>
      
    
  );
}

export default App;
